import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";

import PageLoader from "./PageLoader";
 
import SnackBar from "./SnackBar";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const EditDoctor = () => {
    const { id } = useParams();
    const [selectedCategoryTests, setSelectedCategoryTests] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [categoryValues, setCategoryValues] = useState({}); // Track radio button selection per category
    const [categoryValues1, setCategoryValues1] = useState({});
    const [apiAmounts, setApiAmounts] = useState({});
    const [apiTargets, setApiTargets] = useState({});
    const [modalAmounts, setModalAmounts] = useState({});
    const [targetAmounts, setTargetAmounts] = useState({});
    const [editingRow, setEditingRow] = useState(null);
    const [apiAmtTypes, setApiAmtTypes] = useState({}); // Add this state
    const [loading, setLoading] = useState(true);
  const [snackBar, setSnackBar] = useState({ message: '', type: '' });
  const token = localStorage.getItem("jwt_token");
    const [formData, setFormData] = useState({
        fname: "",
        lname: "",
        doj: "",
        emp_code: "",
        mobile: "",
        email: "",
        pay_model: "",
        pay_type: "",
        professional_charges: "",
        working_hrs: "",
        In_Time: "",
        Out_Time: "",
        gender: "",
        active: "",

    });

    
    const [error, setError] = useState(null);
    const [testValues, setTestValues] = useState({});
    const [searchQuery, setSearchQuery] = useState("");
    const [categoryAmounts, setCategoryAmounts] = useState({});
    const [categoryTargets, setCategoryTargets] = useState({});

    const [catList, setCategoryList] = useState([]);
    useEffect(() => {
       
        const fetchCategoriesList = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}api/getCategoriesList`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    },
                });

                if (!response.ok) {
                    throw new Error('Failed to fetch categories list');
                }

                const data = await response.json();
                if (data.STATUS ===true && Array.isArray(data.data)) {
                    if (data.data.length === 0) {
                        setError("No categories found.");
                    }else{
                        setCategoryList(data.data);
                    }
                    
                } else {
                    localStorage.removeItem("jwt_token");
                    window.location.href = "/login";
                }
            } catch (error) {
                if(error === "Invalid token"){
                    localStorage.removeItem("jwt_token");
                    window.location.href = "/login";
                }               
            }
        };

        if (token) {
            fetchCategoriesList();
        }
    }, [API_BASE_URL]); // Added API_BASE_URL as dependency

    useEffect(() => {
     
        const fetchDoctorData = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}api/getDoctorsByid/${id}`, {
                    method: "GET", 
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`,
                    },
                });

                const data = await response.json();
                
                if (data.STATUS && data.data) {
                    setFormData(prevData => ({
                        ...prevData,
                        ...data.data
                    }));
                } else {
                    if(data.error === "Invalid token"){
                        localStorage.removeItem("jwt_token");
                        window.location.href = "/login";
                    }
                    
                }
            } catch (error) {
                console.error("Error fetching doctor:", error);
                setError("Failed to load doctor data.");
            } finally {
                setLoading(false);
            }
        };

        if (token && id) {
            fetchDoctorData();
        } else {
            setError("Missing authentication token or doctor ID");
            setLoading(false);
        }
    }, [id, API_BASE_URL]);


    useEffect(() => {
        

        if (formData.emp_code) {
            fetch(`${API_BASE_URL}api/getDoctorCategoriesAmounts?emp_code=${formData.emp_code}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            })
                .then((response) => response.json())
                .then((data) => {
                    if (data.STATUS) {
                        // Map tc_id to amt
                        const amountsData = {};
                        const targetsData = {};
                        const amtTypesData = {};
                        data.data.forEach((category) => {
                            amountsData[String(category.tc_id)] = category.amt;
                            targetsData[String(category.tc_id)] = category.target;
                            amtTypesData[String(category.tc_id)] = category.amt_type || 'amount';
                        });
                        console.log("Processed Amounts:", amountsData);
                        console.log("Processed Amounts:", targetsData);
                        setApiAmounts(amountsData);
                        setApiTargets(targetsData);
                        setApiAmtTypes(amtTypesData);
                        // Initialize categoryValues with amt_type from API
                        setCategoryValues(amtTypesData);
                        setApiTargets(targetsData);
                        

                    }else{
                        setError("No category amounts found for this doctor.");
                    }
                })
                .catch((error) => console.error("API Error:", error));
        }
    }, [formData.emp_code]);

    const fetchTestsDetailsToState = () => {
        if (formData.emp_code) {
            fetch(`${API_BASE_URL}api/getDoctorTestsAmounts/${formData.emp_code}`, {
                method: "GET",
                headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
            })
                .then((response) => response.json())
                .then((data) => {
                    if (data.STATUS) {
                        const initialTestValues = {};
                        data.data.forEach((test) => {
                            initialTestValues[test.ts_id] = { amount: test.amt || "", target: test.target || "", type: test.amt_type || "amount" };
                        });
                        setTestValues(initialTestValues);
                        setModalAmounts(initialTestValues);
                        setTargetAmounts(initialTestValues);
                        console.log("Test Values:", initialTestValues);

                    }
                })
                .catch(console.error);
        }
    }

    useEffect(() => {
        fetchTestsDetailsToState();
    }, [formData.emp_code, API_BASE_URL, setTestValues, setModalAmounts, setTargetAmounts]);



    


    const handleCategoryClick = (categoryId) => {
       
        fetch(`${API_BASE_URL}api/getTestsByCatid?tc_id=${categoryId}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
            },
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.STATUS && data.data) {
                    setSelectedCategoryTests(data.data);

                    setTestValues(prev => {
                        return data.data.reduce((acc, test) => {
                            if (!prev[test.ts_id]) {
                                acc[test.ts_id] = {
                                    amount: categoryAmounts[categoryId] || "",
                                    target: categoryTargets[categoryId] || "",
                                    type: "amount", // Default to "amount"
                                    edited: false // Default: not edited
                                };
                            } else {
                                acc[test.ts_id] = prev[test.ts_id]; // Keep existing value
                            }
                            return acc;
                        }, { ...prev });
                    });
                    setShowModal({
                        show: true,
                        categoryId: categoryId,
                        hasTarget: formData.pay_model === "Target",
                    });
                } else {
                    setError("No test data found for this category.");
                }
            })
            .catch(() => {
                setError("Failed to load test data.");
            });
    };

    const handleInputNew = (e) => {
        const { name, value } = e.target;

        if (name.startsWith("amount_")) {
            const categoryId = name.split("_")[1];
            const numValue = value === "" ? "" : Number(value);

            // Handle percentage case with max 50
            if (categoryValues[categoryId] === "percentage") {
                const clampedValue = value === "" ? "" : Math.min(Math.max(numValue, 0), 50);
                setCategoryAmounts(prev => ({
                    ...prev,
                    [categoryId]: clampedValue
                }));

                // Update all tests values under this category
                setTestValues(prev => {
                    const updatedValues = { ...prev };
                    selectedCategoryTests.forEach(test => {
                        if (updatedValues[test.ts_id]) {
                            updatedValues[test.ts_id] = {
                                ...updatedValues[test.ts_id],
                                amount: clampedValue
                            };
                        }
                    });
                    return updatedValues;
                });

            } else {
                // For amount, just ensure non-negative
                const nonNegativeValue = value === "" ? "" : Math.max(numValue, 0);
                setCategoryAmounts(prev => ({
                    ...prev,
                    [categoryId]: nonNegativeValue
                }));

                // Update all tests values under this category
                setTestValues(prev => {
                    const updatedValues = { ...prev };
                    selectedCategoryTests.forEach(test => {
                        if (updatedValues[test.ts_id]) {
                            updatedValues[test.ts_id] = {
                                ...updatedValues[test.ts_id],
                                amount: nonNegativeValue
                            };
                        }
                    });
                    return updatedValues;
                });
            }

        } else if (name.startsWith("target_")) {
            const categoryId = name.split("_")[1];
            const numValue = value === "" ? "" : Number(value);

            if (categoryValues[categoryId] === "percentage") {
                const clampedValue = value === "" ? "" : Math.min(Math.max(numValue, 0), 50);
                setCategoryTargets(prev => ({
                    ...prev,
                    [categoryId]: clampedValue
                }));

                // Update all tests target values under this category
                setTestValues(prev => {
                    const updatedValues = { ...prev };
                    selectedCategoryTests.forEach(test => {
                        if (updatedValues[test.ts_id]) {
                            updatedValues[test.ts_id] = {
                                ...updatedValues[test.ts_id],
                                target: clampedValue
                            };
                        }
                    });
                    return updatedValues;
                });

            } else {
                const nonNegativeValue = value === "" ? "" : Math.max(numValue, 0);
                setCategoryTargets(prev => ({
                    ...prev,
                    [categoryId]: nonNegativeValue
                }));

                // Update all tests target values under this category
                setTestValues(prev => {
                    const updatedValues = { ...prev };
                    selectedCategoryTests.forEach(test => {
                        if (updatedValues[test.ts_id]) {
                            updatedValues[test.ts_id] = {
                                ...updatedValues[test.ts_id],
                                target: nonNegativeValue
                            };
                        }
                    });
                    return updatedValues;
                });
            }
        } else {
            setFormData(prevData => ({
                ...prevData,
                [name]: value
            }));
        }
    };
     


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name.startsWith("amount_")) {
            const categoryId = name.split("_")[1];
            setCategoryAmounts((prev) => ({
                ...prev,
                [categoryId]: value,
            }));
        } else if (name.startsWith("target_")) {
            const categoryId = name.split("_")[1];
            setCategoryTargets((prev) => ({
                ...prev,
                [categoryId]: value,
            }));
            // Ensure each test under this category gets the updated target value
            setTestValues((prev) => {
                const updatedTests = { ...prev };

                selectedCategoryTests.forEach((test) => {
                    if (test.tc_id === categoryId) { // Ensure it's for the right category
                        updatedTests[test.ts_id] = {
                            ...updatedTests[test.ts_id],
                            target: value,
                        };
                    }
                });

                return updatedTests;
            });
        } else {
            setFormData((prevData) => ({
                ...prevData,
                [name]: value,
            }));
        }

    };

    // Handle radio button change
    const handleRadioChange = (categoryId, type) => {
        setCategoryValues((prev) => ({
            ...prev,
            [categoryId]: type,
        }));
        if (type === "percentage") {
            // If percentage is selected, validate and set categoryAmounts, categoryTargets within bounds
            setCategoryAmounts((prev) => {
                const currentAmount = prev[categoryId] || 0;
                return {
                    ...prev,
                    [categoryId]: Math.min(Math.max(currentAmount, 0), 50)
                };
            });

            // Also clamp target values when percentage is selected
            setCategoryTargets((prev) => {
                const currentTarget = prev[categoryId] || 0;
                return {
                    ...prev,
                    [categoryId]: Math.min(Math.max(currentTarget, 0), 50)
                };
            });
        }

    };

  const handleModelRadioChange = (testId, type) => {
    // Update the type for the test in testValues state object using the testId key, 
    // and set the new value using the previous state
    // Ensure the testId exists in the testValues object before updating
    if (testValues[testId]){
        setTestValues((prev) => ({
            ...prev,
            [testId]: {
                ...prev[testId],
                type: type,
            },
        }));
    }else{
        console.error(`Test with ID ${testId} not found in testValues`);
        alert(`Test with ID ${testId} not found in testValues`);
    }
        
    
};

    
    

    const handleSubmitCategory = async (categoryId) => {
       
        // Check for missing categoryId and emp_code
        if (!categoryId) {
            alert("Error: No category ID provided.");
            return;
        }
    
        if (!formData.emp_code) {
            alert("Error: Employee code is missing.");
            return;
        }
    
        try {
            // 1. Submit Category Data
            const categorySubmissionData = {
                emp_code: String(formData.emp_code),  // Ensure emp_code is a string
                // Ensure tc_id is a string
                    amt: categoryValues[categoryId] === "percentage" 
                        ? Math.min(Number(categoryAmounts[categoryId] || 0), 50) 
                        : Number(categoryAmounts[categoryId] || apiAmounts[categoryId] || 0),
                target: categoryTargets[categoryId] ? Number(categoryTargets[categoryId]) : 0, // Ensure target is a number
                amt_type: String(categoryValues[categoryId] || "amount"), // Ensure amt_type is a string
                tc_id: String(categoryId), // Ensure tc_id is a string
                createdDTM: new Date().toISOString(), // Timestamp of submission
            };
    
            console.log("Submitting Category Data:", categorySubmissionData);
    
            const categoryResponse = await fetch(`${API_BASE_URL}api/submitDoctorCategories`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(categorySubmissionData),
            });
    
            const categoryData = await categoryResponse.json();
            if (!categoryData.STATUS) {
                alert("Failed to save category.");
                return;
            }
    
            console.log("Category saved successfully!");
    
            // 2. Fetch Tests for the Category
            console.log(`Fetching tests for category: ${categoryId}`);
            const testResponse = await fetch(`${API_BASE_URL}api/getTestsByCatid?tc_id=${categoryId}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });
    
            const testData = await testResponse.json();
    
            if (!testData.STATUS || !Array.isArray(testData.data) || testData.data.length === 0) {
                alert("No tests available for this category.");
                return;
            }
    
            console.log("Fetched Tests:", testData.data);

            if ( testData.data.length > 0) {
                setSnackBar({ message:  'Saved, Generating Total Tests : ' +  testData.data.length , type: 'success' });
              } else {
                setSnackBar({ message:   'Failed to add test', type: 'error' });
              }

    
            // 3. Submit Each Test Individually
            for (const test of testData.data) {
                setLoading(true);
                const testSubmissionData = {
                    emp_code: String(formData.emp_code), // Ensure emp_code is a string
                    ts_id: String(test.ts_id),          // Ensure ts_id is a string
                    test_id: String(test.test_id),
                    tc_id: String(categoryId),          // Ensure tc_id is a string
                    amt: categoryAmounts[categoryId] ? 
                        Number(categoryAmounts[categoryId]) : 
                        (testValues[test.ts_id]?.amount ? 
                            Number(testValues[test.ts_id].amount) : 0), // Ensure amt is a number
                    target: testValues[test.ts_id]?.target ? 
                        Number(testValues[test.ts_id].target) : 
                        Number(categoryTargets[categoryId]) || 0,
                    amt_type: categoryValues[categoryId] || 
                        testValues[test.ts_id]?.type || 
                        'amount' // Add default value 'amount' if both are undefined
                };
    
                console.log("Submitting Test Data:", testSubmissionData);
    
                const testSubmitResponse = await fetch(`${API_BASE_URL}api/insertDocTest`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify(testSubmissionData),
                });
    
                const testSubmitData = await testSubmitResponse.json();
                if (!testSubmitData.STATUS) {
                    console.error(`Failed to save test with ID ${test.ts_id}:`, testSubmitData.message);
                    alert(`Failed to save test with ID ${test.ts_id}. Server says: ${testSubmitData.message}`);
                } else {
                  //  console.log(`Test ${test.ts_id} saved successfully!`);
                }
            }
           
              // Clear the snackbar after 3 seconds and fetch updated data
              setTimeout(() => {
                setSnackBar({ message: '', type: '' });
                // redirect to test list page
             //  window.location.href = '/tests_list';
        
              }, 3000);
              setLoading(false);
              fetchTestsDetailsToState();
          //  alert("Category and all test values saved successfully!");
        } catch (error) {
            console.error("Error during submission:", error);
            alert("An error occurred while saving.");
        }
    };
    
    

    const handleSave = (test) => {
        // Use test.ts_id instead of test.tc_id for accessing values
        const updatedAmount = testValues[test.ts_id]?.amount ?? modalAmounts[test.ts_id];
        const updtTarget = testValues[test.ts_id]?.target ?? targetAmounts[test.ts_id];
        const updatedType = testValues[test.ts_id]?.type;

        // Check if amount is empty or undefined
        if (!updatedAmount && updatedAmount !== 0) {
            alert("Please enter an amount");
            return;
        }

        // API Request Data
        const requestData = {
            emp_code: formData.emp_code,
            ts_id: test.ts_id,
            amt: updatedAmount,
            target: updtTarget || '',
            amt_type: updatedType || 'amount', // Default to 'amount' if type is not specified
        };

    

        fetch(`${API_BASE_URL}api/updateDoctorTestAmount`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(requestData),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.STATUS) {
                    

                    // Update modalAmounts with the new value
                    setModalAmounts((prev) => ({
                        ...prev,
                        [test.ts_id]: updatedAmount,
                    }));
                    // Update targetAmounts with the new value
                    setTargetAmounts((prev) => ({
                        ...prev,
                        [test.ts_id]: updtTarget,
                    }));

                    setEditingRow(null);
                    setSnackBar({ message: 'Test updated successfully!', type: 'success' });


                     
                } else {
                    alert("Failed to update amount.");
                }
            })
            .catch((error) => console.error("API Error:", error));
    };

    const handleFormSubmit = (e) => {
        e.preventDefault();
     

        fetch(`${API_BASE_URL}api/updateDoctor/${id}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
            },
            body: JSON.stringify(formData),
        })
            .then((response) => response.json())
            .then((data) => {
                alert("Doctor updated successfully!");
            })
            .catch((error) => {
                console.error("Error updating doctor:", error);
            });
    };

    const filteredCategories = catList.filter(category =>
        category.test_category.toLowerCase().includes(searchQuery.toLowerCase())
    );


   

    return (
        <div className="wrapper">
            <Sidebar />
            <main className="main-content content-page">
                <div className="position-relative">
                    <Navbar />
                </div>
                {loading && <PageLoader />}
                {snackBar.message && <SnackBar message={snackBar.message} type={snackBar.type} />}
                <div className="content-inner container-fluid pb-0" id="page_layout">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card">
                                <div className="card-header d-flex justify-content-between">
                                    <div className="header-title">
                                        <h4 className="card-title">Doctor Information</h4>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <form className="form-horizontal cust-form-elements" onSubmit={handleFormSubmit}>
                                        <div className="row cust-form-input">
                                            <div className="form-group col-md-3">
                                                <label htmlFor="fname">First Name:</label>
                                                <input type="text" className="form-control form-control-sm my-2" id="fname" name="fname" value={formData.fname} onChange={handleInputChange} />
                                            </div>
                                            <div className="form-group col-md-3">
                                                <label htmlFor="lname">Last Name:</label>
                                                <input type="text" className="form-control form-control-sm my-2" id="lname" name="lname" value={formData.lname} onChange={handleInputChange} />
                                            </div>
                                            <div className="form-group col-md-3">
                                                <label htmlFor="doj">Date of Joining</label>
                                                <input type="date" className="form-control form-control-sm my-2" id="doj" name="doj" value={formData.doj} onChange={handleInputChange} />
                                            </div>
                                            <div className="form-group col-md-3">
                                                <label htmlFor="emp_code">BMID</label>
                                                <input type="text" className="form-control form-control-sm my-2" id="emp_code" name="emp_code" value={formData.emp_code} onChange={handleInputChange} />
                                            </div>
                                            <div className="form-group col-md-3">
                                                <label htmlFor="mobile">Mobile Number:</label>
                                                <input type="text" className="form-control form-control-sm my-2" id="mobile" name="mobile" value={formData.mobile} onChange={handleInputChange} />
                                            </div>
                                            <div className="form-group col-md-3">
                                                <label htmlFor="email">Email Id</label>
                                                <input type="text" className="form-control form-control-sm my-2" id="email" name="email" value={formData.email} onChange={handleInputChange} />
                                            </div>
                                            <div className="form-group col-md-3">
                                                <label>Pay Model</label>
                                                <select className="form-control form-control-sm my-2" id="pay_model" name="pay_model" value={formData.pay_model} onChange={handleInputChange}>
                                                    <option value="">Select</option>
                                                    <option value="Fixed">Fixed</option>
                                                    <option value="Target">Target</option>
                                                    <option value="Minimum_Guarantee">Minimum Guarantee</option>
                                                    <option value="Case_Based">Case Based</option>
                                                </select>
                                            </div>
                                            <div className="form-group col-md-3">
                                                <label htmlFor="working_hrs">Working Hours:</label>
                                                <input type="text" className="form-control form-control-sm my-2" id="working_hrs" name="working_hrs" value={formData.working_hrs} onChange={handleInputChange} />
                                            </div>
                                            <div className="form-group col-md-3">
                                                <label htmlFor="gender">Gender:</label>
                                                <select className="form-control form-control-sm my-2" id="gender" name="gender" value={formData.gender} onChange={handleInputChange}>
                                                    <option value="M">Male</option>
                                                    <option value="F">Female</option>
                                                </select>
                                            </div>
                                            <div className="form-group col-md-3">
                                                <label htmlFor="active">Status:</label>
                                                <select className="form-control form-control-sm my-2" id="active" name="active" value={formData.active} onChange={handleInputChange}>
                                                    <option value="Active">Active</option>
                                                    <option value="Inactive">Inactive</option>
                                                </select>
                                            </div>
                                            <div className="d-flex gap-2">
                                                <button type="submit" className="btn btn-sm btn-primary-subtle">Save</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className="card-body d-flex justify-content-center">
                                    <div
                                        className="category-list-container"
                                        style={{
                                            border: "1px solid #ccc",
                                            borderRadius: "10px",
                                            padding: "1px",
                                            height: "300px",
                                            overflowY: "scroll",
                                            width: "70%", // Set width to 70%
                                            margin: "0 auto", // Center horizontally
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            position: "relative", // Ensures the content scrolls but the sticky elements stay fixed
                                        }}
                                    >
                                        {/* Sticky Heading */}
                                        <h5
                                            style={{
                                                textAlign: "center",
                                                position: "sticky",
                                                top: "0", // Stick the heading to the top
                                                backgroundColor: "#f8f9fa", // Light background color for the heading
                                                zIndex: 1, // Ensure heading is above other content
                                                padding: "10px 0", // Some padding for aesthetics
                                                marginBottom: "10px", // Space between heading and the search box
                                                width: "100%", // Make sure it takes the full width
                                                borderBottom: "1px solid #ccc", // Optional: border at the bottom to distinguish it
                                            }}
                                        >
                                            Categories
                                        </h5>

                                        {/* Sticky Search Input */}
                                        <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            placeholder="Search categories"
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)} // Update searchQuery state
                                            style={{
                                                width: "100%",
                                                marginBottom: "10px",
                                                position: "sticky",
                                                top: "40px", // Make sure it doesn't overlap with the heading
                                                zIndex: 1, // Ensure search box is above list items
                                                backgroundColor: "#f8f9fa", // Light background color for the search input
                                                borderBottom: "1px solid #ccc", // Optional: border at the bottom to distinguish it
                                            }}
                                        />
                                        {/* Category List */}
                                        
                                        <ul className="list-group" style={{ width: "100%", backgroundColor: "transparent" }}>
                                           {/* check length else put   */}
                                        {filteredCategories.length === 0 ? (
                                            <li className="list-group-item text-center">
                                                <div className="spinner-border text-primary" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                                <p>Loading categories...</p>
                                            </li>
                                        ) : (
                                            filteredCategories.map((category, index) => (
                                                <li
                                                    key={index}
                                                    className="list-group-item"
                                                    style={{
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "center",
                                                        padding: "10px",
                                                        backgroundColor: "transparent", // Ensures the category items have no background color
                                                    }}
                                                >
                                                    <span
                                                        style={{
                                                            cursor: "pointer",
                                                            flex: "1",
                                                            maxWidth: "200px", 
                                                            whiteSpace: "nowrap",
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis"
                                                        }}
                                                        onClick={() => handleCategoryClick(category.id)}
                                                    >
                                                        {category.test_category}
                                                    </span>
                                                    <div style={{ display: "flex", alignItems: "center", gap: "10px", minWidth: "250px", flexWrap: "wrap" }}>
                                                        <input
                                                            type="number" 
                                                            className="form-control form-control-sm"
                                                            style={{ width: "100px" }}
                                                            placeholder={categoryValues[category.id] === "percentage" ? "Percentage" : "Amt"}
                                                            name={`amount_${category.id}`}
                                                            value={categoryAmounts[String(category.id)] ?? apiAmounts[String(category.id)] ?? ""}
                                                            max={categoryValues[category.id] === "percentage" ? 50 : undefined}
                                                            onChange={handleInputNew}
                                                        />
                                                        {formData.pay_model === "Target" && (
                                                            <input
                                                                type="number"
                                                                className="form-control form-control-sm" 
                                                                style={{ width: "100px" }}
                                                                placeholder={categoryValues[category.id] === "percentage" ? "Percentage" : "Target"}
                                                                name={`target_${category.id}`}
                                                                value={categoryTargets[String(category.id)] ?? apiTargets[String(category.id)] ?? ""}
                                                                max={categoryValues[category.id] === "percentage" ? 50 : undefined}
                                                                onChange={handleInputNew}
                                                            />
                                                        )}
                                                        <div style={{ width: "120px" }}>
                                                            <input 
                                                                type="radio"
                                                                name={`radio_${category.id}`}
                                                                value="amount"
                                                                style={{ marginRight: "5px" }}
                                                                checked={!categoryValues[category.id] || categoryValues[category.id] === "amount"}
                                                                onChange={() => handleRadioChange(category.id, "amount")}
                                                            /> Amt &nbsp;
                                                            <input
                                                                type="radio" 
                                                                name={`radio_${category.id}`}
                                                                value="percentage"
                                                                style={{ marginRight: "5px" }}
                                                                checked={categoryValues[category.id] === "percentage"}
                                                                onChange={() => handleRadioChange(category.id, "percentage")}
                                                            /> %
                                                        </div>

                                                        <button
                                                            className="btn btn-sm btn-primary"
                                                            onClick={() => handleSubmitCategory(category.id)}
                                                        >
                                                            Save
                                                        </button>
                                                    </div>
                                                </li>
                                            ))
                                        )}

                                        


                                    
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {showModal.show && (
                    <div 
                        className="modal fade show d-block"
                        tabIndex="-1"
                        role="dialog"
                        style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
                        onClick={() => setShowModal(false)}
                    >
                        <div className="modal-dialog modal-lg modal-dialog-centered" role="document" onClick={e => e.stopPropagation()}>
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Tests List</h5>
                                    <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
                                </div>
                                <div className="modal-body">
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th className="text-center">Test Name</th>
                                                <th className="text-center">Amount</th>
                                                {showModal.hasTarget && (
                                                    <th className="text-center">Target</th>
                                                )}
                                                <th className="text-center">Type</th>
                                                <th className="text-center">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {selectedCategoryTests.length > 0 ? (
                                                selectedCategoryTests.map(test => (
                                                    <tr key={test.ts_id}>
                                                        <td>
                                                            <span title={test.test_name} style={{
                                                                display: "inline-block",
                                                                maxWidth: "300px",
                                                                whiteSpace: "nowrap", 
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis"
                                                            }}>
                                                                {test.test_name}  {test.test_id}
                                                            </span>
                                                        </td>
                                                        <td className="text-center">
                                                            <input
                                                                type="number"
                                                                className="form-control form-control-sm"
                                                                value={testValues[test.ts_id]?.amount ?? modalAmounts[test.ts_id] ?? ""}
                                                                onChange={(e) => {
                                                                    const updatedValue = e.target.value;
                                                                    setTestValues(prev => ({
                                                                        ...prev,
                                                                        [test.ts_id]: {
                                                                            ...prev[test.ts_id],
                                                                            amount: updatedValue
                                                                        }
                                                                    }));
                                                                }}
                                                            />
                                                        </td>
                                                        {showModal.hasTarget && (
                                                            <td className="text-center">
                                                                <input
                                                                    type="number" 
                                                                    className="form-control form-control-sm"
                                                                    value={testValues[test.ts_id]?.target ?? targetAmounts[test.ts_id] ?? ""}
                                                                    onChange={(e) => {
                                                                        const updatedTarget = e.target.value;

                                                                        // Update local state for target
                                                                        setTestValues((prev) => ({
                                                                            ...prev,
                                                                            [test.ts_id]: {
                                                                                ...prev[test.ts_id],
                                                                                target: prev[test.ts_id]?.type === "percentage" ?
                                                                                    Math.min(Math.max(Number(updatedTarget), 0), 50) :
                                                                                    Math.max(Number(updatedTarget), 0),
                                                                            },
                                                                        }));
                                                                    }}
                                                                />
                                                            </td>
                                                        )}
                                                        <td className="text-center">
                                                            <div className="form-check form-check-inline">
                                                                <input
                                                                    type="radio"
                                                                    className="form-check-input"
                                                                    name={`radio_${test.ts_id}`}
                                                                    value="amount"
                                                                    checked={!testValues[test.ts_id]?.type || testValues[test.ts_id]?.type === "amount"}
                                                                    onChange={() => handleModelRadioChange(test.ts_id, "amount")}
                                                                />
                                                                <label className="form-check-label">Amount</label>
                                                            </div>
                                                            <div className="form-check form-check-inline">
                                                                <input
                                                                    type="radio"
                                                                    className="form-check-input"
                                                                    name={`radio_${test.ts_id}`}
                                                                    value="percentage"
                                                                    checked={testValues[test.ts_id]?.type === "percentage"}
                                                                    onChange={() => handleModelRadioChange(test.ts_id, "percentage")}
                                                                />
                                                                <label className="form-check-label">Percentage</label>
                                                            </div>
                                                        </td>
                                                        <td className="text-center">
                                                            <button
                                                                className="btn btn-success btn-sm"
                                                                onClick={() => handleSave(test)}
                                                            >
                                                                Save
                                                            </button>
                                                        </td>

                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan={showModal.hasTarget ? 4 : 3} className="text-center">
                                                        No Tests Available
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

            </main>
        </div>
    );
};
export default EditDoctor;
